module.exports = __webpack_public_path__ + "static/media/gq.14ef492c.svg";